import {
  SET_ERRORS,
  SET_QUESTION,
  SET_QUESTION_ANSWER_LIST,
  SET_SUBMIT_QUESTION,
  CLEAR_QUESTION_ANSWER_LIST,
} from '../types'
import axiosInstance from '../../axios/axiosInstance'
import { apiErrorText } from '../../i18n/apiError'

import store from '../store'

export const clearAnswer = () => {
  store.dispatch({
    type: CLEAR_QUESTION_ANSWER_LIST,
  })
}

export const getQuestion = async (id: string, level: string) => {
  try {
    const res = await axiosInstance.get(`question/?storyId=${id}&level=${level?.toLowerCase() || ''}`)
    const data = res?.data
    const temp: any = []
    if (data && !data.status && !data.statusCode && Object.keys(data) && Object.keys(data).length > 0) {
      store.dispatch({
        type: SET_QUESTION,
        payload: {
          question: data.question,
          memberAnswer: data.memberAnswer && data.memberAnswer.data.answer,
          questionContent: data.questionContent,
        },
      })
      const answers = data?.historicalAnswers.data?.map((ans) => {
        temp.push(...ans.data.answerContent)
        return {
          id: ans.data.memberId,
          name: ans.data.memberName || ans.data.memberId,
          answer: ans.data.answer,
          answerContent: ans.data.answerContent,
          allDataOpContent: [...temp, ...data.questionContent],
        }
      })
      const cursorAfter = data.historicalAnswers.after
      store.dispatch({
        type: SET_QUESTION_ANSWER_LIST,
        payload: {
          answers,
          ref: (cursorAfter && cursorAfter.ref) || null,
          ts: (cursorAfter && cursorAfter.ts) || null,
          count: data.historicalAnswers.count || false,
        },
      })
      return data
    } else {
      throw new Error('Error')
    }
  } catch (error) {
    store.dispatch({
      type: SET_ERRORS,
      payload: 'Error',
    })
    throw error
  }
}

export const getAnswer = (
  id: string,
  level: string,
  memberId: string,
  refId: string,
  refTs: string,
  perPage: number,
) => {
  return (async () => {
    try {
      // const queryString = (refId && refTs && `&afterCursorRef=${refId}&afterCursorTs=${refTs}`) || ''
      const response = await axiosInstance.get(
        `question/answers?storyId=${id}&level=${level?.toLowerCase() || ''}&perPage=${perPage}`,
      )
      const data = response.data
      if (data && Object.keys(data) && Object.keys(data).length > 0) {
        const answers = data.data.map((data) => {
          return {
            id: data.data.memberId,
            name: data.data.memberName || data.data.memberId,
            answer: data.data.answer,
            answerContent: data.data.answerContent,
          }
        })
        const cursorAfter = data.after
        store.dispatch({
          type: SET_QUESTION_ANSWER_LIST,
          payload: {
            answers,
            ref: (cursorAfter && cursorAfter.ref) || null,
            ts: (cursorAfter && cursorAfter.ts) || null,
            count: data.count || false,
          },
        })
        return
      } else {
        throw new Error('Error')
      }
    } catch (error) {
      store.dispatch({
        type: SET_ERRORS,
        payload: 'Error',
      })
      throw error
    }
  })()
}

export const submitAnswer = (payload: {
  memberId: string
  memberName: string
  storyId: string
  answer: string
  correctionAllowedByTeacher: boolean
  level: string
}) => {
  return (async () => {
    try {
      const res = await axiosInstance.post('question', payload)
      const data = res.data
      if (data && !data.status && Object.keys(data) && Object.keys(data).length > 0) {
        store.dispatch({
          type: SET_SUBMIT_QUESTION,
          payload: data.data.answer,
        })
        return data
      } else {
        throw new Error((data && data.message && data.message.message) || 'Error')
      }
    } catch (error: any) {
      store.dispatch({
        type: SET_ERRORS,
        payload: apiErrorText(error) || (error && error.message) || 'Error',
      })
      throw error
    }
  })()
}
